import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {useSelector} from "react-redux";
import useAdvertisement from "./useAdvertisement";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import dayjs from "dayjs";
import {TIMESTAMP_FORMAT} from "../../Constants/Constants";

export default function () {
  const {advertisementFields, handleSubmit, setData, setErrors,} = useAdvertisement();
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    axios.get('advertisements/create').then(res => {
      setData({...res.data.data, products: res.data.data.products});
    });
  }, []);

  const addAdvertisement = data => {
    axios.post('advertisements', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Advertisement "' + res.data.advertisement.name + '" has been created successfully!', {
            icon: "success",
          });
          navigate("/advertisements");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add advertisement" classes="advertisement create">
      <form className="form w-100 row" onSubmit={handleSubmit(addAdvertisement)}>
        {advertisementFields}
        <SubmitButton
          title="Add"
          classes="w-auto d-inline-block mt-10 ml-3"
        />
      </form>
    </Card>
  );
}